import { getDB } from './schema';
import type { LogRow } from '../types/content';

// Queue of display logs awaiting upload. Mirrors LogDAO.

export const logRepo = {
  async add(row: LogRow): Promise<void> {
    const db = await getDB();
    await db.add('logs', row);
  },

  async getBatch(limit = 1000): Promise<LogRow[]> {
    const db = await getDB();
    const all = await db.getAll('logs');
    return all.slice(0, limit);
  },

  async count(): Promise<number> {
    const db = await getDB();
    return db.count('logs');
  },

  async deleteMany(ids: number[]): Promise<void> {
    const db = await getDB();
    const tx = db.transaction('logs', 'readwrite');
    await Promise.all(ids.map((id) => tx.store.delete(id)));
    await tx.done;
  },
};
